export function FaceIdIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M2 5a3 3 0 013-3h2.5a1 1 0 010 2H5a1 1 0 00-1 1v2.5a1 1 0 01-2 0V5zM15.5 3a1 1 0 011-1H19a3 3 0 013 3v2.5a1 1 0 11-2 0V5a1 1 0 00-1-1h-2.5a1 1 0 01-1-1zM4 16.5a1 1 0 10-2 0V19a3 3 0 003 3h2.5a1 1 0 100-2H5a1 1 0 01-1-1v-2.5zM21 15.5a1 1 0 011 1V19a3 3 0 01-3 3h-2.5a1 1 0 110-2H19a1 1 0 001-1v-2.5a1 1 0 011-1zM11 13a1 1 0 11-2 0 1 1 0 012 0zM14 14a1 1 0 100-2 1 1 0 000 2z"
      ></path>
      <path
        fill="currentColor"
        d="M5 12a7 7 0 1114 0 7 7 0 01-14 0zm2 0a5 5 0 109.898-1.01C13.822 10.877 12.41 9.88 11 8c-.841 1.683-2.037 2.658-3.884 2.925A5.02 5.02 0 007 12z"
      ></path>
    </svg>
  );
}
